var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"label":_vm.$t('product_unit'),"items":_vm.items},model:{value:(_vm.unit),callback:function ($$v) {_vm.unit=$$v},expression:"unit"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }